import React from 'react';
// import logo from './logo.svg';
import './App.css';
import AppFrame from './components/AppFrame.js';
import GitHubButton from 'react-github-btn'

function App() {
  return (
    <div
      className="App"
      style={{
          display:'flex',
          flexDirection:'row',
          padding:'0',
          margin:'0',
          width:'100%',
          height:'100vh',
          overflow:'hidden'
      }}
    >
      <AppFrame />
      <div
        style={{
          width:'calc(100% - 690px)',
          boxSizing:'border-box',
          margin:'30px 30px 0 30px',
          height:'600px',
          display:'flex',
          flexDirection:'column'
        }}
      >
        <div
          style={{
            color:'white',
            textAlign:'justify',
            overflowY:'scroll',
            overflowX:'show',
            paddingRight:'20px',
            marginBottom:'20px'
          }}
        >
          <h1 style={{textAlign:'left'}}>Schema Plotting App for graphql-w-persistent</h1>
          <p>
            The graphql-w-persistent library is a middleware for giving a GraphQL interface to your SQL databases. It is so called because it is used in conjunction with the persistent database library return values. Other database libraries are valid database layers for this package if SQL queries are a valid input and if the output is a list to represent a row of Text data values.
          </p>
          <p>
            This library was made for free, but donations and sponsors are appreciatively welcomed as payment or token of gratitude for my work.
          </p>
          <p>
            To the left side, an application is presented to help you organize your schema drawings. Typing the schema json file is mundane, and you also can check for schema properties in the presented application. The application thus far checks against duplicates, against invalid details, and for schema connections (since your GraphQL interface is one less feature if you don’t have a connection between every entity pair in your schema).
          </p>
          <br />
          <p>
            May your computer screen reflect proud faces of hard-work against you,
          </p>
          <p><a href="https://github.com/sponsors/jasonsychau" style={{color:'white'}}>Jason</a></p>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              justifyContent:'space-around',
              alignItems:'center'
            }}
          >
            <a href='https://hackage.haskell.org/package/graphql-w-persistent'><img alt="Hackage" src="https://img.shields.io/hackage/v/graphql-w-persistent?style=flat-square"></img></a>
            <GitHubButton href="https://github.com/jasonsychau/graphql-w-persistent" data-icon="octicon-star" data-size="large" data-show-count="true" aria-label="Star jasonsychau/graphql-w-persistent on GitHub">Star</GitHubButton>
            <GitHubButton href="https://github.com/jasonsychau/graphql-w-persistent/fork" data-icon="octicon-repo-forked" data-size="large" data-show-count="true" aria-label="Fork jasonsychau/graphql-w-persistent on GitHub">Fork</GitHubButton>
            <GitHubButton href="https://github.com/jasonsychau/graphql-w-persistent/issues" data-icon="octicon-issue-opened" data-size="large" data-show-count="true" aria-label="Issue jasonsychau/graphql-w-persistent on GitHub">Issue</GitHubButton>
          </div>
        </div>
        <a href="http://www.anrdoezrs.net/click-9213419-12281392">
        <img src="http://www.tqlkg.com/image-9213419-12281392" width="468" height="60" alt="" border="0"/></a>
      </div>
    </div>
  );
}

export default App;
